'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _has2 = require('./internal/_has');

var _has3 = _interopRequireDefault(_has2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns `true` if `key` exists in `subject`.
 *
 * @example
 * const hasOne = has('one');
 *
 * hasOne({one: 1}) === true;
 * hasOne(Map({two: 2})) === false;
 *
 * @param {any} key
 * @param {Array|Iterable|Object} subject
 * @return {boolean}
 */
exports.default = (0, _curry2.default)(_has3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/has.js
// module id = 1071
// module chunks = 2 3